module.exports = __webpack_public_path__ + "media/images/photo/plans/common/icon-photogallary-7c152a380f14f21d90ff4783723273f9.png";